import clientDetail from './clientDetail'
import getScrollBarSize from './getScrollBarSize';
import getExplore from './getExplore';
import downFile from './downFile'
import getById from './getById';

function cascaderFormat(data) {
  return data.map(i => {
    if (i.children && i.children.length) {
      return {
        value: i.id,
        label: i.name,
        children: cascaderFormat(i.children)
      }
    } else {
      return {
        value: i.id,
        label: i.name
      }
    }
  })
}

function checkLS(fn) {
  if(!!window.localStorage) {
    try {
      fn();
    } catch(e) {
      console.error(e);
    }
  }
}

function onceScollHandle(el, fn) {
  const scrollWrap = document;
  
  const dis = 20;
  const height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
  function scrollFn() {
    // console.log("======")web
      if ( el && (el.getBoundingClientRect().top - height + dis <= 0)) {
        fn();
        scrollWrap.removeEventListener('scroll', scrollFn);
      }
  }
  scrollWrap.addEventListener('scroll', scrollFn);
}


export {
  cascaderFormat,
  checkLS,
  onceScollHandle,
  downFile,
  getById,
  clientDetail,
  getScrollBarSize,
  getExplore,
}



// WEBPACK FOOTER //
// ./src/common/js/utils/index.js